import { render } from "./ListNews.vue?vue&type=template&id=07364406"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__